
import { Link } from "react-router-dom";
import { Logo } from "@/components/ui/logo";
import { ScrollArea } from "@/components/ui/scroll-area";
import { SidebarNavItems } from "./SidebarNavItems";
import { SidebarUserProfile } from "./SidebarUserProfile";
import { useUserProfile } from "@/hooks/useUserProfile";
import { navItems } from "./navItems";
import { useEffect, useRef } from "react";
import { isProfileData } from "@/lib/rpcFunctions";

interface DashboardSidebarProps {
  notifications?: number;
}

export function DashboardSidebar({ notifications = 0 }: DashboardSidebarProps) {
  const mountCountRef = useRef(0);
  const { userData, profile, role, username } = useUserProfile();

  useEffect(() => {
    console.log("[DashboardSidebar] Component mounted");
    console.log("[DashboardSidebar] Current user role:", role);
    console.log("[DashboardSidebar] Profile data:", profile);
    
    return () => {
      console.log("[DashboardSidebar] Component unmounting");
    };
  }, [role, profile]);

  const profileAvatarUrl = isProfileData(profile) ? profile.avatar_url : undefined;
  const userName = isProfileData(profile) ? profile.full_name || 'User' : 'User';
  
  return (
    <div className="w-[280px] border-r bg-background fixed h-screen flex flex-col z-20">
      <div className="p-6 flex flex-col h-full">
        <div className="mb-10">
          <Link to="/">
            <Logo />
          </Link>
        </div>
        
        <ScrollArea className="flex-1 h-[calc(100vh-240px)]">
          {!profile ? (
            <div className="p-4 text-sm text-muted-foreground">Loading navigation...</div>
          ) : (
            <SidebarNavItems 
              items={navItems} 
              userRole={role || 'student'}
            />
          )}
        </ScrollArea>
      
        <SidebarUserProfile 
          userName={userName}
          userEmail={userData?.email}
          avatarUrl={profileAvatarUrl}
          notifications={notifications}
          userRole={role || 'student'}
        />
      </div>
    </div>
  );
}
